// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityOrganizationTree = {
  selectOrganization: "Select Organization",
  organizationsLoadFailed: "Failed to load organizations",
  treeLoadFailed: "Failed to load the organization tree",
  membersLoadFailed: "Failed to load node members",
  treeTitle: "Organization Tree",
  treeDescription:
    "Use the left side to manage structure, switch the member panel by node selection, and add child nodes, edit nodes, or attach members inline.",
  searchPlaceholder: "Search node names",
  dragDisabledDuringSearch:
    "Drag and drop is disabled while search filtering is active. Clear the search to rearrange the tree.",
  emptyTitle: "No organizations available",
  emptyDescription:
    "No organization subject is available yet. Use Create First Organization to initialize one.",
  createFirstOrganization: "Create First Organization",
  bootstrapCreateTitle: "Create First Organization",
  noOrganization: "Select an organization node first",
  organizationSummary: "Organization Summary",
  organizationSummaryHint:
    "Manage the live organization structure and member assignments for the current organization here.",
  totalUnits: "Total Nodes",
  totalMemberships: "Total Memberships",
  leafUnits: "Leaf Nodes",
  emptyLeafUnits: "Empty Nodes",
  subtreeUnits: "Scoped Nodes",
  subtreeMemberships: "Scoped Memberships",
  nodeDetails: "Node Details",
  nodeWorkbench: "Node Workspace",
  nodeMembers: "Direct Members",
  addChild: "Add Child Node",
  editNode: "Edit Node",
  addMember: "Add Member",
  deleteNode: "Delete Node",
  deleteNodeTitle: "Delete Organization Node",
  deleteNodeDescription:
    "Delete node {name}? Only empty nodes without child nodes or direct members can be deleted.",
  deleteNodeConfirm: "Delete Node",
  deleteNodeRootBlocked: "The organization root node cannot be deleted",
  deleteNodeChildrenBlocked: "Remove or move child nodes before deleting this node",
  deleteNodeMembersBlocked: "Remove direct members before deleting this node",
  rootProtectedHint:
    "The root node comes from organization truth. You can add child nodes under it, but cannot edit or move it here.",
  rootNode: "Root",
  organizationHome: "Organization Home",
  directMembersTag: "Direct Members {count}",
  childNodesTag: "Child Nodes {count}",
  selectedNodeLabel: "Node Name",
  organizationUnitKeyLabel: "Node Key",
  parentNodeLabel: "Parent Node",
  childNodes: "Direct Child Nodes",
  directMembers: "Direct Members",
  pathLabel: "Current Path: {path}",
  pathValueLabel: "Node Path",
  organizationUnitLabel: "Assigned Node",
  nodeSummaryRoot:
    "This is the organization root node and the starting point for the whole structure.",
  nodeSummaryLeaf: "{name} has no child nodes yet, so you can assign members to it directly.",
  nodeSummaryBranch: "{name} already has child nodes, so it is suitable for further subdivision.",
  currentNodeEmptyHint:
    "This node has no child nodes and no direct members yet. Add structure or attach members first.",
  childUnits: "Child Nodes",
  childUnitsHint: "Quickly review and manage the direct child nodes of the current node here.",
  childUnitsEmptyTitle: "No child nodes yet",
  childUnitsEmptyDescription: "Create a child node first, then continue assigning members.",
  childUnitLeafHint: "{name} is currently a leaf node and can receive members directly.",
  childUnitBranchHint: "{name} still has child nodes and can be subdivided further.",
  openNode: "Open Node",
  memberManagement: "Member Management",
  directMembersHint:
    "Show only members attached directly to the current node for precise assignment work.",
  noParent: "None",
  userStatus: "User Status",
  membershipStatus: "Membership Status",
  removeMemberTitle: "Remove Organization Member",
  removeMemberDescription: "Remove {user} from {unit}?",
  memberRemoved: "Organization member removed",
  memberRemoveFailed: "Failed to remove organization member",
  memberCreated: "Organization member added",
  memberCreateFailed: "Failed to add organization member",
  nodeMoved: "Organization node moved",
  nodeMoveFailed: "Failed to move organization node",
  nodeDeleted: "Organization node deleted",
  nodeDeleteFailed: "Failed to delete organization node",
  unitCreateTitle: "Create Organization Node",
  unitEditTitle: "Edit Organization Node",
  nodeCreated: "Organization node created",
  nodeCreateFailed: "Failed to create organization node",
  nodeUpdated: "Organization node updated",
  nodeUpdateFailed: "Failed to update organization node",
  unitNameRequired: "Enter the node name",
  organizationNameRequired: "Enter the organization name",
  organizationKeyRequired: "Enter the organization key",
  userRequired: "Select a target user",
  userSearchPlaceholder: "Search username or nickname",
} as const;
